import { render, staticRenderFns } from "./GuardsPerformance.vue?vue&type=template&id=0115a8bd&scoped=true"
import script from "./GuardsPerformance.vue?vue&type=script&lang=js"
export * from "./GuardsPerformance.vue?vue&type=script&lang=js"
import style0 from "./GuardsPerformance.vue?vue&type=style&index=0&id=0115a8bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115a8bd",
  null
  
)

export default component.exports